import fetchJson from '@atlassian/jira-issue-reliability-fetch/src/issue-view-as-json.tsx';
import { transformBackendValueToCmdbObject } from '@atlassian/jira-servicedesk-insight-object-services/src/services/utils.tsx';
import type {
	CmdbObject,
	CmdbObjectResponse,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/cmdb-object.tsx';

export const createFetchObjectDetailsUrl = (workspaceAndObjectId: string) =>
	`/rest/servicedesk/cmdb/latest/object/${workspaceAndObjectId}`;

export const fetchObjectDetails = (workspaceAndObjectId: string): Promise<CmdbObject> =>
	fetchJson(
		createFetchObjectDetailsUrl(workspaceAndObjectId),
		{},
		'fields/service-entity/src/services/fetch-object-details/fetch-object-details',
	).then((object: CmdbObjectResponse) => transformBackendValueToCmdbObject(object));
